export default "__VITE_ASSET__69d83373__"